(function($, _) {
  var ns = window.nspace("ccc.viz.bar.views");

  /**
   * The source/definition/notes that appears below the map
   */
  ns.HeaderView = Backbone.View.extend({
    el: "#bar-chart-container",
    name: "Bar header view",
    templateSelector: "#bar-header-notes-template",

    initialize: function(options) {
      _.bindAll(this, "render", "loadTemplate", "getInitialRenderPromise");

      this.initialRenderPromise = $.Deferred();

      this.selectorsModel = options.selectorsModel;

      this.model.on("change", this.render);
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    render: function() {
      var self, selectorInfo, indicatorName, dataFormatName, templateData;

      self = this;

      // Verify this selector's container is present
      if (this.$el.length === 0) {
        throw "Could not find the " + this.name + " container: " + this.el;
      }

      // Load the template
      this.loadTemplate();

      // Only rerender if the indicator has change from the last render
      if (!this.shouldDrawHeader()) {
        this.currentIndicatorId = this.selectorsModel.get("indicatorId");
        this.dataFormatId = this.selectorsModel.get("dataFormatId");
        this.locationIds = this.selectorsModel.get("locationIds");
        this.characteristicIds = this.selectorsModel.get("characteristicIds");
        return;
      }

      this.currentIndicatorId = this.selectorsModel.get("indicatorId");
      this.dataFormatId = this.selectorsModel.get("dataFormatId");
      this.locationIds = this.selectorsModel.get("locationIds");
      this.characteristicIds = this.selectorsModel.get("characteristicIds");

      // Render the text
      selectorInfo = this.selectorsModel.selectorInfo;
      indicatorName = _.filter(selectorInfo.indicators, function(indicator) {
        return indicator.id === +self.selectorsModel.get("indicatorId");
      })[0].name;
      dataFormatName = _.filter(
        selectorInfo.selectors[self.selectorsModel.get("indicatorId")]
          .dataFormats,
        function(dataFormat) {
          return dataFormat.id === +self.selectorsModel.get("dataFormatId");
        }
      )[0].name;
      templateData = {
        indicatorName: indicatorName,
        dataFormatName: dataFormatName
      };

      // Render the output
      self
        .$("h4.bar-header")
        .html(self.template(templateData))
        // Animate the transition
        .hide()
        .fadeIn(function() {
          self.initialRenderPromise.resolve();
        });
    },

    shouldDrawHeader: function() {
      // Only rerender if the indicator has change from the last render
      if (this.selectorsModel.get("indicatorId") !== this.currentIndicatorId) {
        return true;
      }

      if (this.selectorsModel.get("dataFormatId") !== this.dataFormatId) {
        return true;
      }

      if (this.locationIds && !this.locationIds.length) {
        return true;
      }

      if (this.characteristicIds && !this.characteristicIds.length) {
        return true;
      }

      return false;
    }
  });
})(jQuery, _);
